
export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-r from-[#00A040] to-[#006030] relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10">
        {/* 限定感ブロック */}
        <div className="bg-[#FFD700] text-[#003366] px-6 py-3 rounded-full inline-block mb-6 font-bold text-sm animate-pulse">
          <i className="ri-gift-line mr-2"></i>
          今だけ！入会特典最大12,000円相当
        </div>

        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            地域密着型クレジットカードで地域のおトクを手に入れよう
          </h2>
          
          {/* キャンペーン情報 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-white/30">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-gift-line text-4xl text-[#FFD700]"></i>
              <div className="text-left">
                <p className="text-white/90 text-sm">新規入会特典</p>
                <p className="text-3xl font-bold text-white">最大12,000円相当</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典①</p>
                <p className="text-white">直売所<br />5%割引</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典②</p>
                <p className="text-white">ガソリン<br />2円引き</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典③</p>
                <p className="text-white">初年度<br />年会費無料</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-4">
            <a
              href="https://www.ad.jacard.cr.mufg.jp/af/?utm_source=affiliate&utm_medium=A8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-10 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 cursor-pointer whitespace-nowrap text-lg"
            >
              <i className="ri-bank-card-line w-5 h-5 flex items-center justify-center"></i>
              <span>公式サイトで申し込む（PR）</span>
            </a>
            <a
              href="https://www.jabank.org/kouza/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white/20 hover:bg-white/30 text-white font-bold px-10 py-5 rounded-full border-2 border-white transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap text-lg"
            >
              <i className="ri-building-line w-5 h-5 flex items-center justify-center"></i>
              <span>まず提携金融機関口座を開設</span>
            </a>
          </div>

          {/* 安心ポイント */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm mb-4">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>地域密着の特典</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>直売所5%OFF</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>ガソリン2円引き</span>
            </div>
          </div>

          <p className="text-green-200 text-xs">
            ※このカードの申込みには提携金融機関口座が必要です
          </p>
        </div>
      </div>
    </section>
  );
}
